module.exports = "/fonts/themify.ttf?e23a7dcaefbde4e74e263247aa42ecd7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/themify-icons/fonts/themify.ttf
// module id = 57
// module chunks = 23